import { render, staticRenderFns } from "./JiShiWaitClock.vue?vue&type=template&id=10313889&scoped=true&"
import script from "./JiShiWaitClock.vue?vue&type=script&lang=js&"
export * from "./JiShiWaitClock.vue?vue&type=script&lang=js&"
import style0 from "./JiShiWaitClock.vue?vue&type=style&index=0&id=10313889&scoped=true&lang=scss&"
import style1 from "./JiShiWaitClock.vue?vue&type=style&index=1&id=10313889&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10313889",
  null
  
)

export default component.exports